let seq = 0;

/**
 * Returns a process-unique realtime topic for postgres_changes
 * subscriptions. supabase-js returns the existing channel instance for a
 * duplicate topic, and calling .on() after .subscribe() throws — which
 * unmounts the whole React tree when it happens inside an effect. Hooks
 * that may be mounted more than once (or remounted while an async setup
 * is in flight) must not share topics.
 *
 * Do NOT use this for presence/broadcast channels: those topics are
 * cross-client rooms and must match between users.
 */
export function uniqueChannelName(base: string): string {
  seq += 1;
  return `${base}:i${seq}`;
}
